/* global axios */
import ApiClient from './ApiClient';

class PlaybooksAPI extends ApiClient {
  constructor() {
    super('playbooks', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { playbook: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { playbook: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getPhases(id) {
    return axios.get(`${this.url}/${id}/phases`);
  }

  createPhase(id, data) {
    return axios.post(`${this.url}/${id}/phases`, { phase: data });
  }

  updatePhase(id, phaseId, data) {
    return axios.patch(`${this.url}/${id}/phases/${phaseId}`, { phase: data });
  }

  deletePhase(id, phaseId) {
    return axios.delete(`${this.url}/${id}/phases/${phaseId}`);
  }

  reorderPhases(id, phaseIds) {
    return axios.patch(`${this.url}/${id}/phases/reorder`, {
      phase_ids: phaseIds,
    });
  }

  getStages(id, phaseId) {
    return axios.get(`${this.url}/${id}/phases/${phaseId}/stages`);
  }

  createStage(id, phaseId, data) {
    return axios.post(`${this.url}/${id}/phases/${phaseId}/stages`, {
      stage: data,
    });
  }

  updateStage(id, phaseId, stageId, data) {
    return axios.patch(
      `${this.url}/${id}/phases/${phaseId}/stages/${stageId}`,
      { stage: data }
    );
  }

  deleteStage(id, phaseId, stageId) {
    return axios.delete(
      `${this.url}/${id}/phases/${phaseId}/stages/${stageId}`
    );
  }

  reorderStages(id, phaseId, stageIds) {
    return axios.patch(`${this.url}/${id}/phases/${phaseId}/stages/reorder`, {
      stage_ids: stageIds,
    });
  }

  getDocumentRequests(id) {
    return axios.get(`${this.url}/${id}/document_requests`);
  }

  createDocumentRequest(id, data) {
    return axios.post(`${this.url}/${id}/document_requests`, {
      document_request: data,
    });
  }

  updateDocumentRequest(id, requestId, data) {
    return axios.patch(`${this.url}/${id}/document_requests/${requestId}`, {
      document_request: data,
    });
  }

  deleteDocumentRequest(id, requestId) {
    return axios.delete(`${this.url}/${id}/document_requests/${requestId}`);
  }

  reorderDocumentRequests(id, ids) {
    return axios.patch(`${this.url}/${id}/document_requests/reorder`, {
      document_request_ids: ids,
    });
  }
}

export default new PlaybooksAPI();
